import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getGeneroPorId } from 'services/servicioGet';
import { TipoGenerico } from 'utils/models/types';

interface GeneroState {
  genero: TipoGenerico;
  loadingGenero: boolean;
  errorGenero: string | null;
}

// Estado inicial del slice
const initialState: GeneroState = {
  genero: {
    Id: 0,
    Nombre: '',
  },
  loadingGenero: false,
  errorGenero: null,
};

// Thunk para obtener los géneros
export const fetchGeneroPorId = createAsyncThunk<TipoGenerico, void, { rejectValue: string }>(
  'fetchGeneroPorId',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getGeneroPorId();
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de género por id
const generoPorIdSlice = createSlice({
  name: 'genero',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchGeneroPorId.pending, state => {
        state.loadingGenero = true;
        state.errorGenero = null;
      })
      .addCase(fetchGeneroPorId.fulfilled, (state, action) => {
        state.genero = action.payload;
        state.loadingGenero = false;
      })
      .addCase(fetchGeneroPorId.rejected, (state, action) => {
        state.loadingGenero = false;
        state.errorGenero = action.payload as string;
      });
  },
});

export default generoPorIdSlice.reducer;
